import { render, staticRenderFns } from "./SoSearch.vue?vue&type=template&id=12e91947"
import script from "./SoSearch.vue?vue&type=script&lang=js"
export * from "./SoSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports